import { render, staticRenderFns } from "./MainRules.vue?vue&type=template&id=c1504daa&scoped=true"
import script from "./MainRules.vue?vue&type=script&lang=js"
export * from "./MainRules.vue?vue&type=script&lang=js"
import style0 from "./MainRules.vue?vue&type=style&index=0&id=c1504daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1504daa",
  null
  
)

export default component.exports